import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 29,
		height: 29,
		rx: 4.5,
		fill: "#FAE8E0",
		stroke: "#BF4A4C"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.6613 17.7873L14.2053 8.89531H17.0173L16.5423 17.7873H14.6613ZM15.6113 22.3283C15.1679 22.3283 14.8006 22.1826 14.5093 21.8913C14.2179 21.6 14.0723 21.2516 14.0723 20.8463C14.0723 20.441 14.2179 20.099 14.5093 19.8203C14.8006 19.529 15.1679 19.3833 15.6113 19.3833C16.0546 19.3833 16.4156 19.529 16.6943 19.8203C16.9729 20.099 17.1123 20.441 17.1123 20.8463C17.1123 21.2516 16.9729 21.6 16.6943 21.8913C16.4156 22.1826 16.0546 22.3283 15.6113 22.3283Z",
		fill: "#BF4A4C"
	})]
});
export default SvgError;
